module.exports = __webpack_public_path__ + "static/media/invite.2925b474.svg";